"use strict";
((Shopify.contentCreator.accordion = {
  init: function () {
    const t = $(".accordion > dt > a, [data-cc-accordion] > dt > a");
    ($(".accordion > dd, [data-cc-accordion] > dd").attr("aria-hidden", !0),
      t.attr("aria-expanded", !1),
      t.on("click", function () {
        let e = "false" === $(this).attr("aria-expanded");
        return (
          $(this).attr("aria-expanded", e),
          $(this).parent().next().attr("aria-hidden", !e),
          !1
        );
      }),
      t.on("keydown", function (t) {
        13 === (t.keyCode || e.which) && $(this).trigger("activate");
      }));
  },
  unload: function () {
    ($(".accordion > dt > a, [data-cc-accordion] > dt > a").off(
      "click activate",
    ),
      $(".accordion > dt > a, [data-cc-accordion] > dt > a").off("keydown"));
  },
}),
  (Shopify.contentCreator.slideshow = {
    init: function () {
      ($(".slider, .flexslider").find("li").unwrap(),
        $(".slider, .flexslider").flickity({ pageDots: !0, lazyLoad: 2 }));
    },
  }),
  (Shopify.theme.animation = {
    init: function () {
      $("[data-scroll-class]").waypoint(
        function () {
          const e = $(this.element).data("scroll-class");
          $(this.element).addClass("animated").addClass(e);
        },
        { offset: "70%" },
      );
    },
    slideTransition: function (e, t, o) {
      (e
        .parents(".flickity-enabled")
        .find(".animated")
        .removeClass("animated " + t),
        e.addClass("animated").addClass(t));
    },
    unload: function (e) {
      e.data("scroll-class", "");
    },
  }));
const deferred = {};
function floatToString(e, t) {
  var o = e.toFixed(t).toString();
  return o.match(/^\.\d+/) ? "0" + o : o;
}
if (
  ((Shopify.theme.asyncView = {
    load: (e, t, o = {}) => {
      let i;
      if (e in deferred) return deferred[e];
      const a = $.Deferred();
      if (((deferred[e] = a), o.hash && ((i = sessionStorage.getItem(e)), i))) {
        const t = JSON.parse(i);
        if (o.hash === t.options.hash)
          return (delete deferred[e], a.resolve(t).promise());
      }
      return (
        $.ajax({
          url: e,
          cache: !1,
          data: `view=${t}`,
          dataType: "html",
          headers: { "cache-control": "no-cache" },
          success: (t) => {
            const i = document.createElement("div");
            i.innerHTML = t;
            const n = JSON.parse(i.querySelector("[data-options]").innerHTML),
              s = i.querySelectorAll("[data-html]");
            let r = {};
            if (1 === s.length && "" === s[0].getAttribute("data-html"))
              r = s[0].innerHTML;
            else
              for (let e = 0; e < s.length; e++)
                r[s[e].getAttribute("data-html")] = s[e].innerHTML;
            if (o.hash)
              try {
                sessionStorage.setItem(
                  e,
                  JSON.stringify({ options: n, html: r }),
                );
              } catch (e) {
                console.error(e);
              }
            return (delete deferred[e], a.resolve({ options: n, html: r }));
          },
          error: () => (delete deferred[e], a.reject()),
        }),
        a.promise()
      );
    },
  }),
  (Shopify.theme.addImageDimension = function (e, t) {
    var o = e.lastIndexOf(".");
    return e.substring(0, o) + t + e.substring(o);
  }),
  (Shopify.theme.breadcrumbs = {
    init: function (e) {
      if (e > 1) {
        const e = document.querySelector("[data-breadcrumb-text]"),
          t = document.querySelector(".paginate").dataset.currentPage
            ? document.querySelector(".paginate").dataset.currentPage
            : 1,
          o = document.querySelector(".paginate").dataset.paginatePages;
        (document
          .querySelector(".js-breadcrumb-text")
          .classList.remove("is-hidden"),
          (e.innerHTML = `${Shopify.translation.page_text} ${t} ${Shopify.translation.of_text} ${o}`));
      }
    },
    unload: function (e) {
      document.querySelector(".js-breadcrumb-text").classList.add("is-hidden");
    },
  }),
  (Shopify.theme.disclosure = {
    enable: function () {
      const e = $("[data-disclosure]"),
        t = $("[data-disclosure-toggle]"),
        o = $(".disclosure__list-wrap"),
        i = $("[data-disclosure-list]");
      function a(e) {
        e.siblings(".disclosure__list-wrap").is(":off-right") &&
          e.siblings(".disclosure__list-wrap").addClass("disclosure--left");
      }
      function n(e, i) {
        (!0 === e
          ? (t.not(i).removeClass("is-clicked"),
            t.not(i).attr("aria-expanded", "false"))
          : (t.removeClass("is-clicked"), t.attr("aria-expanded", "false")),
          o.removeClass("disclosure--left"));
      }
      ($("body").on("keyup", function (e) {
        "27" == e.which && n();
      }),
        e.on("mouseleave", function (e) {
          n();
        }),
        e
          .find(".disclosure-list__item:last-child")
          .on("focusout", function (e) {
            n();
          }),
        t.on("mouseenter focus", function (e) {
          n(!0, this);
          const t = $(e.currentTarget);
          (t.attr("aria-expanded", "true").addClass("is-clicked"), a(t));
        }),
        i.on("touchstart", function (e) {
          const t = $(e.currentTarget);
          (t.parents(".disclosure").addClass("is-clicked"),
            n(!0, this),
            0 == t.hasClass("is-clicked")
              ? (t.attr("aria-expanded", "true").addClass("is-clicked"), a(t))
              : (t.attr("aria-expanded", "false").removeClass("is-clicked"),
                o.removeClass("disclosure--left")));
        }),
        i.on("focusout", function (e) {
          n(!0, this);
        }),
        i.on("change", function (e) {
          if (
            Shopify.media_queries.medium.matches ||
            !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
              navigator.userAgent,
            )
          ) {
            const t = $(e.currentTarget),
              o = e.currentTarget.value,
              i = t
                .parents(".selectors-form__item")
                .find("[data-disclosure-input]"),
              a = t.parents(".selectors-form");
            t.hasClass("custom-currency")
              ? t.trigger("click")
              : (i.val(o), a.submit());
          }
        }));
    },
    unload: function () {
      ($("[data-disclosure]").off(),
        $("[data-disclosure-toggle]").off(),
        $(".disclosure__list-wrap").off());
    },
  }),
  (Shopify.theme.dropdownMenu = function () {
    const e = $(".navbar-link"),
      t = $(".navbar-dropdown"),
      o = $(".has-mega-menu");
    (e.each(function (e, t) {
      let o = !1;
      ($(t).on("keydown", function (e) {
        13 === e.which &&
          (!1 === o && e.preventDefault(),
          $(this).closest(".navbar-item").addClass("show-dropdown"),
          (o = !0));
      }),
        $(t)
          .closest(".navbar-item")
          .on("focusout", function (e) {
            0 === $(this).find(e.relatedTarget).length &&
              $(t).closest(".navbar-item").removeClass("show-dropdown");
          }));
    }),
      t.each(function (e, t) {
        let o = !1;
        $(t).on("keydown", function (e) {
          13 === e.which &&
            (!1 === o && e.preventDefault(),
            $(this).find(".has-submenu").length > 0 &&
              $(this).addClass("show-nested-dropdown"),
            (o = !0));
        });
      }),
      o.each(function (e, t) {
        let o = !1;
        ($(t).on("keydown", function (e) {
          13 === e.which &&
            (!1 === o && e.preventDefault(),
            $(this).find(".mega-menu").addClass("mega-menu--show"),
            (o = !0));
        }),
          $(t).on("focusout", function (e) {
            0 === $(t).find(e.relatedTarget).length &&
              $(t).find(".mega-menu").removeClass("mega-menu--show");
          }));
      }));
  }),
  (Shopify.theme.newsletterAjaxForm = {
    init: function () {
      $(".newsletter-form__wrapper .contact-form").each(function () {
        const e = $(this);
        e.on("submit", function (t) {
          "true" !== $('input[name="challenge"]', e).val() &&
            ($.ajax({
              type: e.attr("method"),
              url: e.attr("action"),
              data: e.serialize(),
              success: function (t) {
                e.fadeOut("slow", () => {
                  e.prev(".form__success-message").html(
                    Shopify.translation.newsletter_form_success,
                  );
                });
              },
              error: function (t) {
                ($('input[name="challenge"]', e).val("true"), e.submit());
              },
            }),
            t.preventDefault());
        });
      });
    },
    unload: function () {
      $(".newsletter-form__wrapper .contact-form").find(":submit").off();
    },
  }),
  (Shopify.theme.getSectionData = function (e) {
    const t = e.attr("id").replace("shopify-section-", "");
    var o = e.find("[data-section-data][data-section-id=" + t + "]").first();
    if (!o) return {};
    var i = o.data("section-data") || o.html();
    try {
      return JSON.parse(i);
    } catch (e) {
      return (
        console.warn(`Sections: invalid section data found. ${e.message}`),
        {}
      );
    }
  }),
  (Shopify.theme.infiniteScroll = {
    init: function () {
      ((this.defaults = {
        grid: "[data-load-more--grid]",
        gridItems: "[data-load-more--grid-item]",
      }),
        $("body").on("click", "[data-load-more]", function (e) {
          e.preventDefault();
          const t = $(this),
            o = t.attr("href");
          Shopify.theme.infiniteScroll.loadNextPage(o, t);
        }),
        $("body").on("click", "[data-load-more-infinite]", function (e) {
          return (
            Shopify.theme.infiniteScroll.enableInfinite(),
            $(this).remove(),
            e.stopPropagation(),
            !1
          );
        }),
        $("[data-load-infinite-scroll]").length &&
          Shopify.theme.infiniteScroll.enableInfinite());
    },
    loadNextPage: function (e, t) {
      $.ajax({
        type: "GET",
        dataType: "html",
        url: e,
        beforeSend: function () {
          t.addClass("is-loading");
        },
        success: (e) => {
          t.removeClass("is-loading");
          const o = $(e).find(this.defaults.gridItems),
            i = $(e).find("[data-load-more]").attr("href");
          ($("[data-load-more]").attr("href", i),
            $(this.defaults.grid).first().append(o),
            Shopify.theme.productReviews.init(),
            void 0 === i && $("[data-load-more]").addClass("is-hidden"));
        },
        error: function (e, t, o) {
          (console.log(e),
            console.log(t),
            console.log(o),
            location.replace(
              location.protocol + "//" + location.host + filterURL,
            ));
        },
      });
    },
    enableInfinite: function () {
      new Waypoint.Infinite({
        element: $(this.defaults.grid)[0],
        items: "[data-load-more--grid-item]",
        more: "[data-load-infinite]",
        loadingClass: "loading-in-progress",
        onBeforePageLoad: function () {
          $("[data-load-infinite]").removeClass("is-hidden");
        },
        onAfterPageLoad: function (e) {
          Shopify.theme.productReviews.init();
        },
      });
    },
    unload: function () {
      ($("[data-load-more]").off(), $("[data-load-infinite]").off());
    },
  }),
  (Shopify.theme.flickityIosFix = function () {
    var e,
      t = !1;
    (document.body.addEventListener("touchstart", function (o) {
      o.target.closest(".flickity-slider")
        ? ((t = !0), (e = { x: o.touches[0].pageX, y: o.touches[0].pageY }))
        : (t = !1);
    }),
      document.body.addEventListener(
        "touchmove",
        function (o) {
          if (t && o.cancelable) {
            var i = {
              x: o.touches[0].pageX - e.x,
              y: o.touches[0].pageY - e.y,
            };
            Math.abs(i.x) > 7 && o.preventDefault();
          }
        },
        { passive: !1 },
      ));
  }),
  (Shopify.theme.loadScript = function (e, t, o) {
    Shopify.theme[e] ||
      $.ajax({ url: t, dataType: "script", success: o, async: !1 });
  }),
  (Shopify.theme.applyMasonry = function (e, t) {
    let o = $(".gallery-type--masonry");
    o.length > 0 &&
      o.imagesLoaded().progress(function () {
        o.isotope({
          layoutMode: "masonry",
          itemSelector: e,
          percentPosition: !0,
          masonry: { columnWidth: e, gutter: t },
        });
      });
  }),
  (Shopify.theme.applyHorizontalMasonry = function () {
    $(".gallery-type--horizontal-masonry")
      .find(".gallery__item")
      .each(function (e) {
        var t,
          o,
          i = $(this);
        setTimeout(function () {
          ((t = i.find("img").width()),
            (o = i.find("img").height()),
            i.css("flex-basis", (200 * t) / o),
            i.css("flex-grow", (200 * t) / o),
            i.find("i").css("padding-bottom", (o / t) * 100 + "%"));
        }, 100);
      });
  }),
  (Shopify.theme.mobileMenu = {
    init: function () {
      ((this.$mobileMenuToggle = $("[data-show-mobile-menu]")),
        (this.$mobileMenuIcon = $(".mobile-menu__toggle-icon")),
        (this.$mobileDropDownToggle = $(".mobile-menu .close-dropdown")),
        $("body").on("click", '[data-show-mobile-menu="false"]', function () {
          Shopify.theme.mobileMenu.open();
        }),
        $("body").on("click", '[data-show-mobile-menu="true"]', function () {
          Shopify.theme.mobileMenu.close();
        }),
        !0 === Shopify.theme.jsHeader.enable_sticky && this.enableSticky());
    },
    open: function () {
      let e = window.scrollY;
      $("body").attr("data-current-position", e);
      let t = 0,
        o = parseInt($(".mobile-header").height());
      (void 0 !== Shopify.theme.jsAnnouncementBar &&
        Shopify.theme.jsAnnouncementBar.enable_sticky &&
        (t = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight()),
        $(".mobile-menu").css({ height: `calc(100vh - ${o + t}px)` }),
        $(".mobile-menu__content").css({ marginBottom: `${o + t}px` }),
        this.$mobileMenuIcon.addClass("is-active"),
        $("[data-show-mobile-menu]").attr("data-show-mobile-menu", !0),
        void 0 !== Shopify.theme.jsAjaxCart &&
          (Shopify.theme.jsAjaxCart.hideMiniCart(),
          Shopify.theme.jsAjaxCart.hideDrawer()),
        setTimeout(function () {
          $("body").addClass("mobile-menu--opened");
        }, 10));
    },
    close: function () {
      $("body").removeClass("mobile-menu--opened");
      let e = $("body").data("current-position");
      (window.scrollTo(0, e),
        this.$mobileMenuIcon.removeClass("is-active"),
        $("[data-show-mobile-menu]").attr("data-show-mobile-menu", !1));
    },
    enableSticky: function () {
      Shopify.theme.jsHeader.disableSticky();
      let e = $("#mobile-header"),
        t = 0;
      (void 0 !== Shopify.theme.jsAnnouncementBar &&
        Shopify.theme.jsAnnouncementBar.enable_sticky &&
        (t = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight()),
        e.addClass("sticky--enabled"),
        e
          .sticky({
            wrapperClassName: "header-sticky-wrapper",
            zIndex: 40,
            topSpacing: t,
          })
          .on("sticky-start", () => {
            var t =
              $("#mobile-header").height() +
              $(".announcement-sticky-wrapper").height();
            e.parent()
              .parent()
              .find(".search-overlay")
              .addClass("sticky-search")
              .css("top", t + "px");
          })
          .on("sticky-end", () => {
            (e
              .parent()
              .parent()
              .find(".search-overlay")
              .removeClass("sticky-search")
              .css("top", "100%"),
              setTimeout(() => {
                e.sticky("update");
              }, 250),
              e.find(".sticky-menu-wrapper").removeClass("is-visible"));
          }));
    },
    disableSticky: function () {
      let e = $("#mobile-header");
      (e.unstick(),
        e.removeClass("sticky--enabled"),
        setTimeout(function () {
          $(".header-sticky-wrapper").css("height", "auto");
        }, 250));
    },
    unload: function (e) {
      ($("[data-mobilemenu-toggle]").off(),
        $(".mobile-menu__toggle-icon").off(),
        $(".mobile-menu .close-dropdown").off(),
        this.disableSticky());
    },
  }),
  (Shopify.theme.objectFitImages = {
    init: function () {
      (objectFitImages(),
        "color" == Shopify.theme_settings.image_loading_style &&
          this.calculateAspectRatio());
    },
    calculateAspectRatio: function () {
      const e = document.querySelectorAll("[data-calculate-aspect-ratio]");
      for (let t = 0; t < e.length; t++) {
        const o = e[t].firstElementChild,
          i = o.getAttribute("width") / o.getAttribute("height"),
          a = o.height * i;
        e[t].style.maxWidth = `${Math.floor(a)}px`;
      }
      document.addEventListener("lazyloaded", function (e) {
        e.srcElement.parentNode.style.background = "none";
      });
    },
    unload: function () {},
  }),
  void 0 === Shopify)
)
  var Shopify = {};
if (
  ((Shopify.each = function (e, t) {
    for (var o = 0; o < e.length; o++) t(e[o], o);
  }),
  (Shopify.map = function (e, t) {
    for (var o = [], i = 0; i < e.length; i++) o.push(t(e[i], i));
    return o;
  }),
  (Shopify.arrayIncludes = function (e, t) {
    for (var o = 0; o < e.length; o++) if (e[o] == t) return !0;
    return !1;
  }),
  (Shopify.uniq = function (e) {
    for (var t = [], o = 0; o < e.length; o++)
      Shopify.arrayIncludes(t, e[o]) || t.push(e[o]);
    return t;
  }),
  (Shopify.isDefined = function (e) {
    return void 0 !== e;
  }),
  (Shopify.getClass = function (e) {
    return Object.prototype.toString.call(e).slice(8, -1);
  }),
  (Shopify.extend = function (e, t) {
    function o() {}
    ((o.prototype = t.prototype),
      (e.prototype = new o()),
      (e.prototype.constructor = e),
      (e.baseConstructor = t),
      (e.superClass = t.prototype));
  }),
  (Shopify.locationSearch = function () {
    return window.location.search;
  }),
  (Shopify.locationHash = function () {
    return window.location.hash;
  }),
  (Shopify.replaceState = function (e) {
    window.history.replaceState({}, document.title, e);
  }),
  (Shopify.urlParam = function (e) {
    var t = RegExp("[?&]" + e + "=([^&#]*)").exec(Shopify.locationSearch());
    return t && decodeURIComponent(t[1].replace(/\+/g, " "));
  }),
  (Shopify.newState = function (e, t) {
    return (
      (Shopify.urlParam(e)
        ? Shopify.locationSearch().replace(
            RegExp("(" + e + "=)[^&#]+"),
            "$1" + t,
          )
        : "" === Shopify.locationSearch()
          ? "?" + e + "=" + t
          : Shopify.locationSearch() + "&" + e + "=" + t) +
      Shopify.locationHash()
    );
  }),
  (Shopify.setParam = function (e, t) {
    Shopify.replaceState(Shopify.newState(e, t));
  }),
  (Shopify.Product = function (e) {
    Shopify.isDefined(e) && this.update(e);
  }),
  (Shopify.Product.prototype.update = function (e) {
    for (let t in e) this[t] = e[t];
  }),
  (Shopify.Product.prototype.optionNames = function () {
    return "Array" == Shopify.getClass(this.options) ? this.options : [];
  }),
  (Shopify.Product.prototype.optionValues = function (e) {
    if (!Shopify.isDefined(this.variants)) return null;
    var t = Shopify.map(this.variants, function (t) {
      var o = "option" + (e + 1);
      return null == t[o] ? null : t[o];
    });
    return null == t[0] ? null : Shopify.uniq(t);
  }),
  (Shopify.Product.prototype.getVariant = function (e) {
    var t = null;
    return (
      e.length != this.options.length ||
        Shopify.each(this.variants, function (o) {
          for (var i = !0, a = 0; a < e.length; a++) {
            o["option" + (a + 1)] != e[a] && (i = !1);
          }
          return 1 == i ? void (t = o) : void 0;
        }),
      t
    );
  }),
  (Shopify.Product.prototype.getVariantById = function (e) {
    for (var t = 0; t < this.variants.length; t++) {
      var o = this.variants[t];
      if (e == o.id) return o;
    }
    return null;
  }),
  (Shopify.money_format = "${{amount}}"),
  (Shopify.formatMoney = function (e, t) {
    function o(e, t) {
      return void 0 === e ? t : e;
    }
    function i(e, t, i, a) {
      if (
        ((t = o(t, 2)), (i = o(i, ",")), (a = o(a, ".")), isNaN(e) || null == e)
      )
        return 0;
      var n = (e = (e / 100).toFixed(t)).split(".");
      return (
        n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
        (n[1] ? a + n[1] : "")
      );
    }
    "string" == typeof e && (e = e.replace(".", ""));
    var a = "",
      n = /\{\{\s*(\w+)\s*\}\}/,
      s = t || this.money_format;
    switch (s.match(n)[1]) {
      case "amount":
      case "amount_with_apostrophe_separator":
        a = i(e, 2);
        break;
      case "amount_no_decimals":
        a = i(e, 0);
        break;
      case "amount_with_comma_separator":
        a = i(e, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        a = i(e, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        a = i(e, 0, ".", " ");
    }
    return s.replace(n, a);
  }),
  (Shopify.OptionSelectors = function (e, t) {
    return (
      (this.selectorDivClass = "selector-wrapper"),
      (this.selectorClass = "single-option-selector"),
      (this.variantIdFieldIdSuffix = "-variant-id"),
      (this.variantIdField = null),
      (this.historyState = null),
      (this.selectors = []),
      (this.domIdPrefix = e),
      (this.product = new Shopify.Product(t.product)),
      (this.onVariantSelected = Shopify.isDefined(t.onVariantSelected)
        ? t.onVariantSelected
        : function () {}),
      this.replaceSelector(e),
      this.initDropdown(),
      t.enableHistoryState &&
        (this.historyState = new Shopify.OptionSelectors.HistoryState(this)),
      !0
    );
  }),
  (Shopify.OptionSelectors.prototype.initDropdown = function () {
    var e = { initialLoad: !0 };
    if (!this.selectVariantFromDropdown(e)) {
      var t = this;
      setTimeout(function () {
        t.selectVariantFromParams(e) ||
          t.fireOnChangeForFirstDropdown.call(t, e);
      });
    }
  }),
  (Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function (
    e,
  ) {
    this.selectors[0].element.onchange(e);
  }),
  (Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown =
    function (e) {
      this.selectVariantFromParams(e) || this.selectVariantFromDropdown(e);
    }),
  (Shopify.OptionSelectors.prototype.replaceSelector = function (e) {
    var t = document.getElementById(e),
      o = t.parentNode;
    (Shopify.each(this.buildSelectors(), function (e) {
      o.insertBefore(e, t);
    }),
      (t.style.display = "none"),
      (this.variantIdField = t));
  }),
  (Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function (e) {
    var t = document
      .getElementById(this.domIdPrefix)
      .querySelector("[selected]");
    if (
      (t ||
        (t = document
          .getElementById(this.domIdPrefix)
          .querySelector('[selected="selected"]')),
      !t)
    )
      return !1;
    var o = t.value;
    return this.selectVariant(o, e);
  }),
  (Shopify.OptionSelectors.prototype.selectVariantFromParams = function (e) {
    var t = Shopify.urlParam("variant");
    return this.selectVariant(t, e);
  }),
  (Shopify.OptionSelectors.prototype.selectVariant = function (e, t) {
    var o = this.product.getVariantById(e);
    if (null == o) return !1;
    for (var i = 0; i < this.selectors.length; i++) {
      var a = this.selectors[i].element,
        n = o[a.getAttribute("data-option")];
      null != n && this.optionExistInSelect(a, n) && (a.value = n);
    }
    return (
      "undefined" != typeof jQuery
        ? jQuery(this.selectors[0].element).trigger("change", t)
        : this.selectors[0].element.onchange(t),
      !0
    );
  }),
  (Shopify.OptionSelectors.prototype.optionExistInSelect = function (e, t) {
    for (var o = 0; o < e.options.length; o++)
      if (e.options[o].value == t) return !0;
  }),
  (Shopify.OptionSelectors.prototype.insertSelectors = function (e, t) {
    (Shopify.isDefined(t) && this.setMessageElement(t),
      (this.domIdPrefix = "product-" + this.product.id + "-variant-selector"));
    var o = document.getElementById(e);
    Shopify.each(this.buildSelectors(), function (e) {
      o.appendChild(e);
    });
  }),
  (Shopify.OptionSelectors.prototype.buildSelectors = function () {
    for (var e = 0; e < this.product.optionNames().length; e++) {
      var t = new Shopify.SingleOptionSelector(
        this,
        e,
        this.product.optionNames()[e],
        this.product.optionValues(e),
      );
      ((t.element.disabled = !1), this.selectors.push(t));
    }
    var o = this.selectorDivClass,
      i = this.product.optionNames(),
      a = Shopify.map(this.selectors, function (e) {
        var t = document.createElement("div");
        if ((t.setAttribute("class", o), i.length > 1)) {
          var a = document.createElement("label");
          ((a.htmlFor = e.element.id),
            (a.innerHTML = e.name),
            t.appendChild(a));
        }
        return (t.appendChild(e.element), t);
      });
    return a;
  }),
  (Shopify.OptionSelectors.prototype.selectedValues = function () {
    for (var e = [], t = 0; t < this.selectors.length; t++) {
      var o = this.selectors[t].element.value;
      e.push(o);
    }
    return e;
  }),
  (Shopify.OptionSelectors.prototype.updateSelectors = function (e, t) {
    var o = this.selectedValues(),
      i = this.product.getVariant(o);
    (i
      ? ((this.variantIdField.disabled = !1),
        (this.variantIdField.value = i.id))
      : (this.variantIdField.disabled = !0),
      this.onVariantSelected(i, this, t),
      null != this.historyState &&
        this.historyState.onVariantChange(i, this, t));
  }),
  (Shopify.OptionSelectorsFromDOM = function (e, t) {
    var o = t.optionNames || [],
      i = t.priceFieldExists || !0,
      a = t.delimiter || "/",
      n = this.createProductFromSelector(e, o, i, a);
    ((t.product = n),
      Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, e, t));
  }),
  Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors),
  (Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector =
    function (e, t, o, i) {
      if (!Shopify.isDefined(o)) o = !0;
      if (!Shopify.isDefined(i)) i = "/";
      var a = document.getElementById(e),
        n = a.childNodes,
        s = (a.parentNode, t.length),
        r = [];
      Shopify.each(n, function (e, a) {
        if (1 == e.nodeType && "option" == e.tagName.toLowerCase()) {
          var n = e.innerHTML.split(new RegExp("\\s*\\" + i + "\\s*"));
          0 == t.length && (s = n.length - (o ? 1 : 0));
          var l = n.slice(0, s),
            c = o ? n[s] : "",
            d =
              (e.getAttribute("value"),
              {
                available: !e.disabled,
                id: parseFloat(e.value),
                price: c,
                option1: l[0],
                option2: l[1],
                option3: l[2],
              });
          r.push(d);
        }
      });
      var l = { variants: r };
      if (0 == t.length) {
        l.options = [];
        for (var c = 0; s > c; c++) l.options[c] = "option " + (c + 1);
      } else l.options = t;
      return l;
    }),
  (Shopify.SingleOptionSelector = function (e, t, o, i) {
    ((this.multiSelector = e),
      (this.values = i),
      (this.index = t),
      (this.name = o),
      (this.element = document.createElement("select")));
    for (var a = 0; a < i.length; a++) {
      var n = document.createElement("option");
      ((n.value = i[a]), (n.innerHTML = i[a]), this.element.appendChild(n));
    }
    return (
      this.element.setAttribute("class", this.multiSelector.selectorClass),
      this.element.setAttribute("data-option", "option" + (t + 1)),
      (this.element.id = e.domIdPrefix + "-option-" + t),
      (this.element.onchange = function (o, i) {
        ((i = i || {}), e.updateSelectors(t, i));
      }),
      !0
    );
  }),
  (Shopify.Image = {
    preload: function (e, t) {
      for (var o = 0; o < e.length; o++) {
        var i = e[o];
        this.loadImage(this.getSizedImageUrl(i, t));
      }
    },
    loadImage: function (e) {
      new Image().src = e;
    },
    switchImage: function (e, t, o) {
      if (e && t) {
        var i = this.imageSize(t.src),
          a = this.getSizedImageUrl(e.src, i);
        o ? o(a, e, t) : (t.src = a);
      }
    },
    imageSize: function (e) {
      var t = e.match(
        /_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./,
      );
      return null != t ? t[1] : null;
    },
    getSizedImageUrl: function (e, t) {
      if (null == t) return e;
      if ("master" == t) return this.removeProtocol(e);
      var o = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
      if (null != o) {
        var i = e.split(o[0]),
          a = o[0];
        return this.removeProtocol(i[0] + "_" + t + a);
      }
      return null;
    },
    removeProtocol: function (e) {
      return e.replace(/http(s)?:/, "");
    },
  }),
  (Shopify.OptionSelectors.HistoryState = function (e) {
    this.browserSupports() && this.register(e);
  }),
  (Shopify.OptionSelectors.HistoryState.prototype.register = function (e) {
    window.addEventListener("popstate", function (t) {
      e.selectVariantFromParamsOrDropdown({ popStateCall: !0 });
    });
  }),
  (Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function (
    e,
    t,
    o,
  ) {
    this.browserSupports() &&
      (!e ||
        o.initialLoad ||
        o.popStateCall ||
        Shopify.setParam("variant", e.id));
  }),
  (Shopify.OptionSelectors.HistoryState.prototype.browserSupports =
    function () {
      return window.history && window.history.replaceState;
    }),
  (Shopify.theme.productMedia = {
    models: [],
    setupMedia: function () {
      const e = {
        controls: ["zoom-in", "zoom-out", "fullscreen"],
        focusOnPlay: !1,
      };
      ($("model-viewer").each(function (t, o) {
        ((o = new Shopify.ModelViewerUI(o, e)),
          Shopify.theme.productMedia.models.push(o));
      }),
        $(".product-gallery__model model-viewer").on("mousedown", function () {
          Shopify.theme.productMedia.hideModelIcon(this);
        }));
    },
    showModelIcon: function (e) {
      $(e).find(".button--poster, .model-icon-button-control").show();
    },
    hideModelIcon: function (e) {
      $(e).find(".button--poster, .model-icon-button-control").hide();
    },
  }),
  (Shopify.theme.productReviews = {
    init: function () {
      ($("#shopify-product-reviews").length ||
        $(".shopify-product-reviews-badge").length) &&
        SPR.$(document).ready(function () {
          return (
            SPR.registerCallbacks(),
            SPR.initRatingHandler(),
            SPR.initDomEls(),
            SPR.loadProducts(),
            SPR.loadBadges()
          );
        });
    },
    productReviewScroll: function () {
      $("#shopify-product-reviews").length &&
        $(".shopify-product-reviews-badge").length &&
        $(".spr-badge-container").on("click", function () {
          Shopify.theme.scrollToTop("#shopify-product-reviews");
        });
    },
    unload: function () {
      $(".spr-badge-container").off();
    },
  }),
  (Shopify.theme.quantityBox = {
    init: function () {
      ($("body").on(
        "click",
        "[data-update-quantity]:not([disabled])",
        function () {
          Shopify.theme.quantityBox.updateQuantity($(this));
        },
      ),
        $("body").on("keyup keydown change", ".quantity-input", function () {
          Shopify.theme.quantityBox.updateQuantity($(this));
        }));
    },
    updateQuantityControls: function (e) {
      const t = e.parents(".product-quantity-box"),
        o = $(".quantity-input", t);
      let i = parseInt(o.val()),
        a = 1e17;
      (null != o.attr("max") && (a = o.attr("max")),
        1 === i || 0 === i
          ? ($(".quantity-minus", t).attr("disabled", !0),
            $(".quantity-plus", t).attr("disabled", !1))
          : i >= a
            ? ($(".quantity-plus", t).attr("disabled", !0),
              $(".quantity-minus", t).attr("disabled", !1),
              o.val(a))
            : ($(".quantity-minus", t).attr("disabled", !1),
              $(".quantity-plus", t).attr("disabled", !1)));
    },
    updateQuantity: function (e) {
      const t = e.parents(".product-quantity-box"),
        o = $(".quantity-input", t);
      t.parents("[data-line-item]").data("line-item");
      let i = parseInt(o.val()),
        a = 1e17,
        n = o.attr("min") || 0;
      if ((null != o.attr("max") && (a = o.attr("max")), i < n))
        return (o.val(n), !1);
      if (i > a) return (o.val(a), !1);
      if (
        ("plus" === e.data("update-quantity")
          ? i < a && (i++, o.val(i))
          : "minus" === e.data("update-quantity") && i > n && (i--, o.val(i)),
        e.parents("[data-line-item]").length)
      ) {
        const e = t.data("line-item-key");
        Shopify.theme.quantityBox.updateCart(e, i);
      }
      Shopify.theme.quantityBox.updateQuantityControls(e);
    },
    updateCart: function (lineID, quantity) {
      ($(".quantity-warning").removeClass("animated bounceIn"),
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: `quantity=${quantity}&line=${lineID}`,
          dataType: "json",
          success: function (e) {
            let t = 0,
              o = "",
              i = $(`[data-line-item="${lineID}"]`).find(".quantity-warning"),
              a = $(`[data-line-item="${lineID}"]`).find(
                ".product-quantity-box",
              ),
              n = $(".cart__form").data("currentDiscount");
            const s = lineID - 1;
            void 0 !== e.items[s] && (t = e.items[s].quantity);
            for (let o = 0; o < e.items.length; o++)
              o != s &&
                e.items[o].id == e.items[s].id &&
                (t += e.items[o].quantity);
            (quantity > 0 &&
              quantity != t &&
              e.total_discount <= n &&
              (1 == t
                ? ((o = Shopify.translation.product_count_one),
                  i.text(`${t} ${o}`),
                  $(".quantity-minus", a).attr("disabled", !0))
                : ((o = Shopify.translation.product_count_other),
                  i.text(`${t} ${o}`))),
              $(".cart__form").data("currentDiscount", e.total_discount),
              i.addClass("animated bounceIn"),
              void 0 !== Shopify.theme.jsAjaxCart &&
                Shopify.theme.jsAjaxCart.updateView(),
              Shopify.theme.jsCart &&
                Shopify.theme.jsCart.updateView(e, lineID));
          },
          error: function (XMLHttpRequest) {
            try {
              var response = JSON.parse(XMLHttpRequest.responseText);
              response = response && response.description ? response.description : 'An error occurred';
            } catch (e) {
              response = 'An error occurred. Please try again.';
            }
          },
        }));
    },
    unload: function (e) {
      ($(".quantity-input").off(), $("[data-update-quantity]").off());
    },
  }),
  (Shopify.theme.queryParameters = {}),
  location.search.length)
)
  for (
    var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
    i < aCouples.length;
    i++
  )
    ((aKeyValue = aCouples[i].split("=")),
      aKeyValue.length > 1 &&
        (Shopify.theme.queryParameters[decodeURIComponent(aKeyValue[0])] =
          decodeURIComponent(aKeyValue[1])));
function selectCallback(e, t, o, i) {
  const a = $(e),
    n = $(".product__notify-form", a),
    s = $(".product_form, .shopify-product-form", a),
    r = s.data("variant-inventory"),
    l = s.find(".quantity-input"),
    c = $(".notify_form__inputs"),
    d = Shopify.translation.notify_form_email,
    p = Shopify.translation.contact_email,
    u = Shopify.translation.notify_form_send,
    h = c.data("url");
  let f = "",
    m = "";
  if (o) {
    if (null != o.title) {
      const e = o.title.replace(/"/g, "&quot;");
      f = `${Shopify.translation.email_content}${e} | ${h}?variant=${o.id}`;
    }
  } else f = `${Shopify.translation.email_content} | ${h}`;
  m = c.hasClass("customer--true")
    ? `<input required type="email" class="notify_email input" name="contact[email]" id="contact[email]" placeholder="${d}" value="${Shopify.translation.customer_email}" />`
    : `<input required type="email" class="notify_email input" name="contact[email]" id="contact[email]" placeholder="${d}" value="${p}" />`;
  const y = `\n    <input type="hidden" name="challenge" value="false" />\n    <input type="hidden" name="contact[body]" class="notify_form_message" data-body="${f}" value="${f}" />\n    <div class="field has-addons">\n      <div class="control">\n        ${m}\n      </div>\n      <div class="control">\n        <input class="action_button button" type="submit" value="${u}" />\n      </div>\n    </div>`;
  if (o && o.featured_media && a.is(":visible")) {
    $(".product-gallery__main, .js-gallery-modal", a).each((e, t) => {
      const i = $(t),
        a = window.Flickity.data(t),
        n = $(`img[data-image-id=${o.featured_media.id}]`).data("index");
      i.is(":visible") && void 0 !== a && a.select(n, !1, !0);
    });
  }
  if (
    (s.find("[data-variant-selector]").trigger("selectedVariantChanged"),
    $(".cart-warning", a).text(""),
    o &&
      ($(".sku", a).text(o.sku),
      $(".notify_form_message", a).attr(
        "value",
        `${$(".notify_form_message", a).data("body")} - ${o.title}`,
      )),
    o && o.available)
  ) {
    const e = { ...o, ...((r && r.find((e) => e.id === o.id)) || {}) };
    if (e.inventory_management && e.inventory_quantity > 0) {
      if (Shopify.theme_settings.display_inventory_left) {
        let t = Shopify.translation.product_count_other;
        1 === e.inventory_quantity &&
          (t = Shopify.translation.product_count_one);
        const o = Shopify.theme_settings.inventory_threshold;
        e.inventory_quantity <= o
          ? $(".items_left", a).html(`${e.inventory_quantity} ${t}`)
          : $(".items_left", a).html("");
      }
      "deny" === e.inventory_policy &&
        ($("[data-max-inventory-management]", a).attr(
          "max",
          e.inventory_quantity,
        ),
        Shopify.theme.quantityBox.updateQuantityControls(l));
    } else
      ($(".items_left", a).text(""),
        $("[data-max-inventory-management]", a).removeAttr("max"));
    ($(".sold_out", a).text(""),
      $("[data-add-to-cart-trigger]", a)
        .removeClass("disabled")
        .removeAttr("disabled")
        .attr("data-options-unselected", null)
        .find("span:not(.icon)")
        .text($("[data-add-to-cart-trigger]", a).data("label")),
      Shopify.PaymentButton && Shopify.PaymentButton.init(),
      $(".shopify-payment-button", a).show(),
      $(".purchase-details__quantity", a).show(),
      n.hide(),
      c.empty(),
      c.append(y),
      Shopify.theme.currencyConverter &&
        Shopify.theme.currencyConverter.convertCurrencies());
  } else {
    const e = o ? Shopify.translation.soldOut : Shopify.translation.unavailable;
    ($(".items_left", a).text(""),
      $("[data-max-inventory-management]", a).removeAttr("max"),
      $(".sold_out", a).text(e),
      "not-selected" === i
        ? $("[data-add-to-cart-trigger]", a)
            .removeClass("disabled")
            .removeAttr("disabled")
            .attr("data-options-unselected", "")
            .find("span:not(.icon)")
            .text($("[data-add-to-cart-trigger]", a).data("label"))
        : $("[data-add-to-cart-trigger]", a)
            .addClass("disabled")
            .attr("disabled", "disabled")
            .attr("data-options-unselected", null)
            .find("span:not(.icon)")
            .text(e),
      $(".shopify-payment-button", a).hide(),
      $(".purchase-details__quantity", a).hide(),
      n.hide(),
      c.empty(),
      o && !o.available && (n.fadeIn(), c.empty(), c.append(y)));
  }
}
function isScreenSizeLarge() {
  if (Shopify.media_queries.large.matches) return !0;
}
((Shopify.theme.responsiveVideo = {
  init: function () {
    $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(
      function (e, t) {
        var o = $(t);
        o.parents(".plyr__video-wrapper").length ||
          o.parents(".lazyframe").length ||
          o.wrap('<div class="lazyframe" data-ratio="16:9"></div>');
      },
    );
  },
}),
  (window.selectCallback = selectCallback),
  (Shopify.theme.predictiveSearch = {
    vars: { term: "", searchPath: Shopify.routes.search_url, displayTimer: "" },
    init: function () {
      (this.unload(),
        $("[data-show-search-trigger], [data-autocomplete-true] input").on(
          "click touchstart",
          function (e) {
            if (!isScreenSizeLarge()) {
              e.stopPropagation();
              const t = $(this).closest("form").find('[name="type"]').val(),
                o = $(document).scrollTop();
              Shopify.theme.predictiveSearch.showMobileSearch(t, o);
            }
          },
        ),
        $("[data-autocomplete-true]").on("focus", function () {
          $(this)
            .parents("[data-autocomplete-true]")
            .find(".search__results-wrapper")
            .show();
        }),
        $(document).on("click focusout", function (e) {
          Shopify.media_queries.large.matches &&
            0 === $(e.target).parents(".search-form").length &&
            $("[data-autocomplete-true] .search__results-wrapper")
              .hide()
              .removeClass("results-found");
        }),
        $("[data-autocomplete-true] form").on("submit", function (e) {
          e.preventDefault();
          const t = $(this).find('input[name="q"]').val(),
            o = encodeURI(t);
          let i = Shopify.theme_settings.search_option;
          ($(this).find('[name="type"]').length > 0 &&
            (i = $(this).find('[name="type"]').val()),
            (window.location.href =
              null == o
                ? Shopify.routes.search_url + "?type=" + i
                : Shopify.theme.predictiveSearch.vars.searchPath +
                  "?type=" +
                  i +
                  "&q=" +
                  o +
                  "*"));
        }),
        $("[data-autocomplete-true] form").each(function () {
          const e = $(this),
            t = e.find('input[name="q"]'),
            o = `\n        <div class="search__results-wrapper">\n          <h2 class="vertical-search__title">\n            ${Shopify.translation.top_suggestions}\n          </h2>\n          <ul class="search__results"></ul>\n        </div>\n      `;
          ($(o).appendTo(e),
            t.attr("autocomplete", "off").on("input", function () {
              (clearTimeout(Shopify.theme.predictiveSearch.vars.displayTimer),
                $(this).val().length > 3
                  ? ((Shopify.theme.predictiveSearch.vars.term = $(this).val()),
                    Shopify.theme.predictiveSearch.getResults(
                      Shopify.theme.predictiveSearch.vars.term,
                      e,
                    ))
                  : $("[data-autocomplete-true] .search__results-wrapper")
                      .hide()
                      .removeClass("results-found"));
            }));
        }));
    },
    getResults: function (e, t) {
      let o = Shopify.theme_settings.search_option;
      (t.find('[name="type"]').length > 0 &&
        (o = t.find('[name="type"]').val()),
        jQuery
          .getJSON("/search/suggest.json", {
            q: e,
            resources: {
              type: o,
              limit: Shopify.theme_settings.search_to_display,
              options: {
                unavailable_products: "last",
                fields:
                  "title,body,variants.title,variants.sku,vendor,product_type,tag",
              },
            },
          })
          .done(function (e) {
            const o = [
              e.resources.results.products,
              e.resources.results.pages,
              e.resources.results.articles,
            ];
            let i = [];
            ($.each(o, function (e, t) {
              void 0 !== t && t.length > 0 && i.push(t);
            }),
              (Shopify.theme.predictiveSearch.vars.displayTimer = setTimeout(
                function () {
                  Shopify.theme.predictiveSearch.displayResults(i[0], t);
                },
                500,
              )));
          }));
    },
    displayResults: function (e, t) {
      const o = t.find(".search__results-wrapper"),
        i = t.find(".search__results");
      let a = Shopify.theme_settings.search_option;
      if (
        (o.show(),
        i.empty(),
        t.find('[name="type"]').length > 0 &&
          (a = t.find('[name="type"]').val()),
        e && e.length > 0)
      )
        ($.each(e, function (e, t) {
          let o = $('<a tabindex="0"></a>').attr("href", t.url);
          if (
            ("/" !== Shopify.routes.root_url &&
              (o = $('<a tabindex="0"></a>').attr(
                "href",
                Shopify.routes.root_url + t.url,
              )),
            t.price)
          ) {
            function a(e) {
              return (
                '<span class="money">' +
                Shopify.formatMoney(e, $("body").data("money-format")) +
                "</span>"
              );
            }
            let n;
            ((n =
              !0 === t.available
                ? t.compare_at_price_max > t.price_max ||
                  t.compare_at_price_min > t.price_min
                  ? `${a(t.price)} <span class="was-price">${a(t.compare_at_price_max)}</span>`
                  : t.price > 0
                    ? t.price_min != t.price_max
                      ? `${Shopify.translation.from} ${a(t.price)}`
                      : `${a(t.price)}`
                    : Shopify.theme_settings.free
                : Shopify.translation.soldOut),
              t.image &&
                o.append(
                  `<div class="thumbnail"><img class="lazyload transition--${Shopify.theme_settings.image_loading_style}" src="${Shopify.theme.addImageDimension(t.image, "_300x")}" /></div>`,
                ),
              o.append(
                `<div class="description"><strong>${t.title}</strong><br><span class="item-pricing price">${n}</span></div>`,
              ));
          } else
            t.summary_html
              ? ("NULL" != t.image &&
                  o.append(
                    `<div class="thumbnail"><img class="lazyload transition--${Shopify.theme_settings.image_loading_style}" src="${Shopify.theme.addImageDimension(t.image, "_300x")}" /></div>`,
                  ),
                o.append(
                  `<div class="description"><strong>${t.title}</strong><br><span class="item-description">'${t.summary_html.replace(/(<([^>]+)>)/gi, "").slice(0, 25)}</span></div>`,
                ))
              : t.published_at &&
                o.append(
                  `<div class="description"><strong>${t.title}</strong><br><span class="item-description">${t.body.replace(/(<([^>]+)>)/gi, "").slice(0, 25)}</span></div>`,
                );
          (o.wrap('<li class="item-result"></li>'),
            i.append(o.parent()),
            Shopify.theme.currencyConverter &&
              Shopify.theme.currencyConverter.init());
        }),
          i.prepend(
            `<li class="all-results"><span class="see-all"><a href="${this.vars.searchPath}?type=${a}&q=${this.vars.term}*"> ${Shopify.translation.all_results} ${Shopify.icons.right_caret}</a></span></li>`,
          ),
          i.parents(".search__results-wrapper").addClass("results-found"));
      else {
        const e = `<li class="item-result"><span class="no-results">${Shopify.translation.no_results}</span></li>`;
        (i.append(e),
          i.parents(".search__results-wrapper").removeClass("results-found"));
      }
      (t.parents(".vertical-header__content").length &&
        "vertical" === Shopify.theme.jsHeader.header_layout &&
        Shopify.theme.predictiveSearch.alignVerticalSearch(),
        i.show());
    },
    showMobileSearch: function (e, t) {
      ($("body").css("max-height", window.innerHeight),
        $(".mobile-search").fadeIn(200),
        /iPad|iPhone|iPod/.test(navigator.platform) ||
        ("MacIntel" === navigator.platform && navigator.maxTouchPoints > 1)
          ? $(".mobile-search input[data-q]").focus()
          : setTimeout(function () {
              $(".mobile-search input[data-q]").focus();
            }, 205),
        (document.body.style.position = "fixed"),
        (document.body.style.top = "-" + t + "px"),
        $(".mobile-search").css("top", t));
      const o = window.innerHeight - 46;
      ($(".mobile-search .search__results-wrapper").css("max-height", o),
        e
          ? $('.mobile-search [name="type"]').val(e)
          : $('.mobile-search [name="type"]').val(
              Shopify.theme_settings.search_option,
            ),
        $(".search-form .close-search").on("click touchstart", function (e) {
          (e.preventDefault(),
            e.stopPropagation(),
            Shopify.theme.predictiveSearch.hideMobileSearch(t),
            $("[data-autocomplete-true] .search__results-wrapper")
              .hide()
              .removeClass("results-found"));
        }),
        $(".search-form .submit-search").on("click touchstart", function (e) {
          $(this).parents("form").submit();
        }));
    },
    hideMobileSearch: function (e) {
      ($("body").css("max-height", "none"),
        (document.body.style.position = ""),
        (document.body.style.top = ""),
        window.scrollTo(0, e),
        $(".mobile-search").fadeOut(200),
        $('.mobile-search [name="q"]').val(""),
        $("body").off("focus", ".search-form .close-search"),
        $("body").off("focus", ".search-form .submit-search"));
    },
    alignVerticalSearch: function () {
      const e = $(".header--vertical .search__results"),
        t = $(".header--vertical").innerWidth();
      e.parents(".search__results-wrapper").css({
        position: "fixed",
        left: t,
        top: "0",
      });
    },
    unload: function () {
      ($("body").off("focus", "[data-autocomplete-true] input"),
        $('input[name="q"]').off(),
        $('[data-dropdown-rel="search"], [data-autocomplete-true] input').off(),
        $(".search__results-wrapper").remove());
    },
  }),
  (Shopify.theme.scrollToTop = function (e, t) {
    null != t
      ? $("html, body").animate({ scrollTop: $(e).offset().top - t }, 1e3)
      : $("html, body").animate({ scrollTop: $(e).offset().top }, 1e3);
  }),
  (Shopify.theme.tabs = {
    enableTabs: function () {
      let e = $(".tabs li, .tabs li a");
      e.on("click", function (t) {
        (t.preventDefault(),
          e.removeClass("is-active active"),
          $(this).addClass("is-active"));
        let o = $(this).index(),
          i = $(this).parents(".tabs").next(".tabs-content");
        (i.children("li, li a").removeClass("is-active active"),
          i
            .children("li, li a")
            .eq(o)
            .addClass("is-active")
            .show()
            .css({ display: "block" })
            .siblings()
            .hide()
            .removeClass("is-active"));
      });
    },
    unload: function () {
      $(".tabs li, .tabs li a").off();
    },
  }));
class ProductCard {
  enableSwatches() {
    window.isScreenSizeLarge() &&
      $("body").on("mouseenter", ".swatch span", ({ currentTarget: e }) => {
        -1 === $(e).data("image").indexOf("no-image") &&
          ($(e)
            .parents(".thumbnail")
            .find(".product__imageContainer img:not(.secondary)")
            .attr("src", $(e).data("image")),
          $(e)
            .parents(".thumbnail")
            .find(".product__imageContainer img:not(.secondary)")
            .attr("srcset", $(e).data("image")));
      });
  }
  showVariantImage() {
    window.isScreenSizeLarge() &&
      ($("body").on(
        "mouseenter",
        ".has-secondary-image-swap",
        ({ currentTarget: e }) => {
          const t = $(e).find(".product-image__wrapper img"),
            o = $(e).find(".product-image__wrapper .video-on-hover");
          (t && t.toggleClass("swap--visible"),
            o &&
              (o.toggleClass("swap--visible"),
              Shopify.theme.video.enableVideoOnHover($(e))));
        },
      ),
      $("body").on(
        "mouseleave",
        ".has-secondary-image-swap",
        ({ currentTarget: e }) => {
          const t = $(e).find(".product-image__wrapper img"),
            o = $(e).find(".product-image__wrapper .video-on-hover");
          (t && t.toggleClass("swap--visible"),
            o &&
              (o.toggleClass("swap--visible"),
              Shopify.theme.video.disableVideoOnHover($(e))));
        },
      ));
  }
  showQuickShop() {
    $("body").on("click", ".js-quick-shop-link", (e) => {
      e.preventDefault();
      const t = $(e.currentTarget);
      Shopify.theme.jsProductClass
        .load(t.data("url"))
        .then(({ html: e }) => {
          ($(".js-quick-shop").html(e.content),
            $(".js-quick-shop .js-product_section").addClass("quickshop"),
            $(".fancybox-active").length ||
              $.fancybox.open($(".js-quick-shop"), {
                baseClass: `quick-shop__lightbox product-${t.data("id")}`,
                hash: !1,
                infobar: !1,
                toolbar: !1,
                loop: !0,
                smallBtn: !0,
                touch: !1,
                video: { autoStart: !1 },
                mobile: { preventCaptionOverlap: !1, toolbar: !0 },
                afterShow: (e, t) => {
                  const { src: o } = t,
                    i = $(o).find(".quick-shop");
                  (Shopify.theme.jsProduct.init($(".js-quick-shop")),
                    i.addClass("quick-shop--loaded"),
                    i.addClass("content-loaded"));
                },
                beforeClose: (e, t) => {
                  const { src: o } = t,
                    i = $(o).find(".quick-shop");
                  (i.removeClass("quick-shop--loaded"),
                    i.removeClass("content-loaded"));
                },
              }));
        })
        .catch((t) => console.error(e));
    });
  }
}
Shopify.theme.thumbnail = new ProductCard();
const videoEl = {
    playButtonIcon:
      '<button type="button" class="plyr__control plyr__control--overlaid" aria-label="Play, {title}" data-plyr="play"><svg class="play-icon-button-control" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23 20V40L39 29.4248L23 20Z" fill="#323232"/></svg><span class="plyr__sr-only">Play</span></button>',
    playButton:
      '<button type="button" class="plyr__controls__item plyr__control" aria-label="Play, {title}" data-plyr="play"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Pause</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span></button>',
    muteButton:
      '<button type="button" class="plyr__controls__item plyr__control" aria-label="Mute" data-plyr="mute"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span></button>',
    progressInput:
      '<div class="plyr__controls__item plyr__progress__container"><div class="plyr__progress"><input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek"><progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress><span role="tooltip" class="plyr__tooltip">00:00</span></div></div>',
    volume:
      '<div class="plyr__controls__item plyr__volume"><input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume"></div>',
    fullscreen:
      '<button type="button" class="plyr__controls__item plyr__control" data-plyr="fullscreen"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span></button>',
  },
  videoControls = `${videoEl.playButtonIcon}<div class="plyr__controls"> ${videoEl.playButton} ${videoEl.progressInput} ${videoEl.muteButton} ${videoEl.volume} ${videoEl.fullscreen}</div>`;
let videoPlayers = [],
  videosInRecommendedProductsPlayer;
Shopify.theme.video = {
  init: function () {
    this.setupVideoPlayer();
  },
  setupVideoPlayer: function () {
    const e = document.querySelectorAll(
      "[data-html5-video] video, [data-youtube-video]",
    );
    let t = Plyr.setup(e, {
        controls: videoControls,
        ratio: this.aspect_ratio,
        fullscreen: { enabled: !0, fallback: !0, iosNative: !0 },
        storage: { enabled: !1 },
      }),
      o = $("[data-video-loop]").data("video-loop") || !1;
    ($.each(t, function (e, t) {
      ((t.loop = o), videoPlayers.push(t));
    }),
      this.setupListeners());
  },
  setupListeners: function () {
    $.each(videoPlayers, function (e, t) {
      const o = t.id;
      let i;
      (t.isHTML5 &&
        ((i = $(t.elements.wrapper).find("video")),
        i.attr("data-plyr-video-id", o)),
        t.on("play", function (e) {
          var t = e.detail.plyr;
          $.each(videoPlayers, function (e, o) {
            var i = o.id || o.media.dataset.plyrVideoId;
            t.id != i && o.pause();
          });
        }));
    });
  },
  enableVideoOnHover: function (e) {
    var t,
      o = e.find("[data-html5-video]"),
      i = e.find("[data-youtube-video]");
    (o.length > 0
      ? (t = o.find("[data-plyr-video-id]").data("plyr-video-id"))
      : i.length > 0 && (t = i.find("iframe").attr("id")),
      t &&
        $.each(videoPlayers, function (e, o) {
          (o.id != t && o.media.id != t) ||
            (o.toggleControls(!1), (o.muted = !0), o.play());
        }));
  },
  disableVideoOnHover: function (e) {
    var t,
      o = e.find("[data-html5-video]"),
      i = e.find("[data-youtube-video]");
    (o.length > 0
      ? (t = o.find("[data-plyr-video-id]").data("plyr-video-id"))
      : i.length > 0 && (t = i.find("iframe").attr("id")),
      t &&
        $.each(videoPlayers, function (e, o) {
          (o.id != t && o.media.id != t) || (o.playing && o.pause());
        }));
  },
};